<div class="one items">
    <div class="titleOne">
        <h2>Consultations :</h2>
        <div class="groupBubble">
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
        </div>
    </div>
    <div class="consultList">
        <ul>
            <li>Maladies du reflux</li>
            <li>Malabsorbtion</li>
            <li>Intolérances et allergies alimentaires</li>
            <li>Bilan bariatrique</li>
        </ul>
        <ul>
            <li>Maladie coeliaque </li>
            <li>Maladies inflammatoires <ul>
                <li>Crohn</li>
                <li>RCUH</li>
            </ul></li>
            
        </ul>
        <ul>
            <li>Maladies fonctionnelles du tube digestif</li>
            <li>Maladies du foie, vésicule biliaire et pancréas</li>
            <li>Consultations pré techniques spécialisées hospitalières</li>
            <li>Dépistage du cancer du colon</li>
        </ul>
    </div>
</div>
<div class="bottom">
    <div class="twoo items">
        <div class="title">
            <h2>Gastroscopie :</h2>
            <div class="groupBubble">
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
            </div>
        </div>
        <h4>Examen de l’œsophage, de l’estomac et du duodénum</h4>
        <div class="tab">
            <p>Conditions :</p>
            <ul>
                <li>Être à jeun 6h avant l’examen</li>
                <li>Être accompagné</li>
                <li>Être envoyé par son médecin traitant</li>
            </ul>
        </div>
    </div>
    <div class="three items">
        <div class="title">
            <h2>Colonoscopie : </h2>
            <div class="groupBubble">
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
            </div>
        </div>
        <h4>Examen du colon</h4>
        <p>Au cabinet visualisation du colon gauche</p>
        <p>En hospitalisation de jour, colonoscopie totale sous narcose</p>
        <p>Préparation à domicile</p>
    </div>
    <div class="four items">
        <div class="title">
            <h2>Protocologie :</h2>
            <div class="groupBubble">
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
            </div>
        </div>
        <div class="tab">
            <p>Traitements :</p>
            <ul>
                <li>Des hémorrhoïdes
                    <ul>
                        <li>Par injections sclérosantes </li>
                        <li>Par ligatures</li>
                        <li>Par coagulation infra rouge</li>
                    </ul>
                </li>
                <li>Des fissures anales</li>
                <li>De la continence anale</li>
            </ul>
        </div>
    </div>
</div>
<footer>
    <div class="footbar"></div>
</footer>
